const styles = {
  tableContainer: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  table: {
    borderCollapse: 'collapse',
    width: '100%',

    '& td, & th': {
      border: '1px solid #eeeeee',
      textAlign: 'left',
      padding: '6px',
    },
  },
  zebraRow: {
    backgroundColor: '#eeeeee',
  },
  groupSpacer: {
    backgroundColor: '#ffffff',

    '& td': {
      border: 'none',
      padding: 0,
      height: '22px',
      backgroundColor: '#ffffff',
    },
  },

  dolarTable: {
    borderCollapse: 'collapse',
    width: '100%',

    '& td, & th': {
      border: '1px solid #eeeeee',
      textAlign: 'left',
      padding: '6px',
    },
    '& tr:nth-child(even)': {
      backgroundColor: '#eeeeee',
    },
  },
}

export default styles
